<template>
  <div id="burger" :class="{ active: isNavOpened }" @click.prevent="toggleNav">
    <slot>
      <button type="button" class="burger-button" title="Menu">
        <span class="burger-bar burger-bar--1" />
        <span class="burger-bar burger-bar--2" />
        <span class="burger-bar burger-bar--3" />
      </button>
    </slot>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import store from '@/modules/app/store/index'
import { name as appModuleName } from '@/modules/app/store'

export default {
  name: 'Hamburguer',
  computed: {
    ...mapGetters({
      isNavOpened: 'getIsNavOpen',
    }),
    isNavOpened() {
      return store.getters['$_app/getIsNavOpen']
    },
  },
  methods: {
    ...mapActions(appModuleName, ['toggleNav']),
  },
}
</script>

<style scoped>
button {
  cursor: pointer;
}
button:focus {
  outline: 0;
}
.hamburger {
  color: #3f5b60;
  font-size: 30px;
}
.burger-button {
  position: relative;
  height: 30px;
  width: 36px;
  display: block;
  z-index: 999;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.burger-bar {
  background-color: #3f5b60;
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  height: 3px;
  width: auto;
  margin-top: -1px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}
.burger-bar--2 {
  transform-origin: 100% 50%;
  transform: scaleX(1);
}
.burger-button:hover .burger-bar--2 {
  transform: scaleX(1);
}
.no-touchevents .burger-bar--2:hover {
  transform: scaleX(1);
}
.burger-bar--3 {
  transform: translateY(6px);
}
#burger.active .burger-button {
  transform: rotate(-180deg);
}
#burger.active .burger-bar {
  background-color: #3f5b60;
}
#burger.active .burger-bar--1 {
  transform: rotate(45deg);
}
#burger.active .burger-bar--2 {
  opacity: 0;
}
#burger.active .burger-bar--3 {
  transform: rotate(-45deg);
}
</style>
